import { FormContainer } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form';
import { useCallback } from 'react';

import { useSnackbar } from 'notistack';
import { Box, Button, Stack, Typography } from '@mui/material';
import Http from '@/services/http';
import { useItemDrawer } from '@/contexts/drawer';

import UserForm from '../components/user-form';

const CreateUser: React.FC = () => {
  const form = useForm();
  const drawerItem = useItemDrawer();

  const { enqueueSnackbar } = useSnackbar();

  const createUserSubmit = useCallback(
    async (values: any) => {
      const { data, status } = await Http.post(`/fast-tracking-users`, values);

      if (status === 201) {
        enqueueSnackbar('Usuário criado com sucesso!', { variant: 'success' });
        drawerItem.close(data);
      } else if (status === 400 && data?.message) {
        const messages = data.message
          .split(',')
          .map((msg: string) => msg.trim());

        messages.forEach((msg: string) => {
          enqueueSnackbar(msg, { variant: 'error' });
        });
      } else {
        enqueueSnackbar('Ocorreu um erro ao criar o usuário!', {
          variant: 'error',
        });
      }
    },
    [drawerItem, enqueueSnackbar]
  );

  return (
    <Box sx={{ p: 4, flexGrow: 1 }}>
      <Stack spacing={2} sx={{ height: '100%' }}>
        <Typography
          sx={{ textTransform: 'uppercase', fontSize: 20, fontWeight: 'bold' }}
          variant="h1"
        >
          Criar usuário
        </Typography>
        <FormContainer
          formContext={form}
          FormProps={{
            style: { flexGrow: 1, display: 'flex', flexDirection: 'column' },
            autoComplete: 'false',
          }}
          onSuccess={createUserSubmit}
        >
          <Box sx={{ flexGrow: 1 }}>
            <UserForm showPasswordField />
          </Box>
          <Stack direction="row" spacing={1}>
            <Button type="submit" variant="contained">
              Criar
            </Button>
            <Button onClick={() => drawerItem.close()}>Cancelar</Button>
          </Stack>
        </FormContainer>
      </Stack>
    </Box>
  );
};

export default CreateUser;
